import moment from "moment";

import { getSkipReason } from "../helpers";

const formatDay = (value?: string | null) =>
  value ? moment(value).format("MMM D, YYYY") : "not set";

export const formatScheduleValue = (
  field: string,
  value: string | number | null,
) => {
  if (field.endsWith("_offset")) {
    return typeof value === "number"
      ? `${value} ${value === 1 ? "day" : "days"} after employee start date`
      : "not set";
  }
  return formatDay(typeof value === "string" ? value : null);
};

export const formatReminderSchedule = (
  scheduledDate?: string | null,
  daysAfterStartDate?: number,
) => {
  if (scheduledDate) {
    return `due ${formatDay(scheduledDate)}`;
  }
  if (typeof daysAfterStartDate === "number") {
    return `${daysAfterStartDate} ${
      daysAfterStartDate === 1 ? "day" : "days"
    } after kickoff`;
  }
  return "";
};

/** A reason is a notification skip reason only when the event was skipped. */
export const getActivitySkipReason = (
  status: string | null | undefined,
  payload: unknown,
) => (status === "skipped" ? getSkipReason(payload) : null);
